import { render, staticRenderFns } from "./my-task-header.vue?vue&type=template&id=72bd682c&scoped=true&"
import script from "./my-task-header.vue?vue&type=script&lang=ts&"
export * from "./my-task-header.vue?vue&type=script&lang=ts&"
import style0 from "./my-task-header.vue?vue&type=style&index=0&id=72bd682c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd682c",
  null
  
)

export default component.exports